// extracted by mini-css-extract-plugin
export var component = "EcpMiniNavigation-module--component--05b1d";
export var fadePop = "EcpMiniNavigation-module--fade-pop--132fb";
export var growHeightIn = "EcpMiniNavigation-module--grow-height-in--179b7";
export var icon = "EcpMiniNavigation-module--icon--f337f";
export var link = "EcpMiniNavigation-module--link--4b4f1";
export var links = "EcpMiniNavigation-module--links--2a959";